export default __webpack_public_path__ + "static/media/videoicon.a1ead223.png";